import { PlanPillLabel } from './PlanPill.types'

export const pillTextColorsByLabelV2 = {
  [PlanPillLabel.FREE]: 'masterWeb.sky3',
  [PlanPillLabel.PRO]: 'masterWeb.flowblue2',
  [PlanPillLabel.PRO_PLUS]: 'masterWeb.flowblue2',
  [PlanPillLabel.PRO_FLEX]: 'masterWeb.flowblue4',
  [PlanPillLabel.PILOT]: 'masterWeb.flowblue2',
  [PlanPillLabel.ENTERPRISE]: 'masterWeb.purple3'
}

export const pillBackgroundColorsByLabelV2 = {
  [PlanPillLabel.FREE]: 'masterWeb.sky1',
  [PlanPillLabel.PRO]: 'masterWeb.flowblue1',
  [PlanPillLabel.PRO_PLUS]: 'masterWeb.flowblue1',
  [PlanPillLabel.PRO_FLEX]: 'masterWeb.flowblue1',
  [PlanPillLabel.PILOT]: 'masterWeb.flowblue1',
  [PlanPillLabel.ENTERPRISE]: 'masterWeb.purple1'
}
